import { render, staticRenderFns } from "./SimpleReportTable.vue?vue&type=template&id=31bfd084&"
import script from "./SimpleReportTable.vue?vue&type=script&lang=js&"
export * from "./SimpleReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports